<!-- eslint-disable vue/valid-v-for -->
<template>
  <b-button-group size="sm">
    <b-button
      v-for="imagePlacement in allValues"
      @click="handleValue(imagePlacement)"
      :disabled="disabled"
      :class="{ 'highlighted' : valueDisplayed === imagePlacement }"
    >
      <i :class="`fa-kit fa-arrow-${imagePlacement}`" />
    </b-button>
  </b-button-group>
</template>
<script>

function initialData() {
  return {
    valueSelected: null,
  };
}

export default {
  name: 'ImagePlacement',
  props: {
    disabled: {
      type: Boolean,
      default: false,
    },
    value: {
      type: String,
      default: 'top',
    },
    isHorizontalPlacement: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return initialData();
  },
  computed: {
    allValues() {
      return !this.isHorizontalPlacement ? ['top', 'bottom', 'full'] : ['right', 'left', 'full'];
    },
    valueDisplayed() {
      return this.valueSelected || this.value;
    },
  },
  methods: {
    handleValue(value) {
      this.valueSelected = value;
      this.$emit('updateValue', value);
    },
  },
};
</script>
<style scoped lang="scss">
.highlighted {
  background-color: $primary;
  color: $white;
}
</style>
